interface CameraShieldProps {
  className?: string;
  color?: string;
}

export default function CameraShield({ className = '', color = '#06B6D4' }: CameraShieldProps) {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M20 3L7 8.5V18.5C7 27.25 13.05 35.35 20 37C26.95 35.35 33 27.25 33 18.5V8.5L20 3Z'
        fill={color}
        fillOpacity='0.15'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M27 16V22C27 22.55 26.55 23 26 23H14C13.45 23 13 22.55 13 22V16C13 15.45 13.45 15 14 15H16.5L17.5 13H22.5L23.5 15H26C26.55 15 27 15.45 27 16Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx='20' cy='19' r='2.5' stroke={color} strokeWidth='1.5' />
    </svg>
  );
}
